import { push } from 'connected-react-router';
import * as actionTypes from './actionTypes';
import { carregarInscricao } from './inscricao.actions';
import { autenticarComLogin, logoff } from '../servicos/autenticacao';
import { apiDaInscricao } from '../servicos/axios';
import { cargaInicial } from './cargaInicial.actions';
import { obteveInformacoesDoTitular } from './dadosTitular.actions';
import { ACESSO_ADMINISTRATIVO } from '../helpers/tiposDeAcesso';

export const efetuarLoginSucesso = dadosLogin =>
  ({ type: actionTypes.EFETUAR_LOGIN_SUCESSO, dadosLogin });

export const logOut = () =>
  ({ type: actionTypes.LOG_OUT });

export const efetuarLogin = dadosLogin =>
  async dispatch => {
    const cpf = dadosLogin.cpf.replace(/\.|-/g, '');
    const resultado = await autenticarComLogin(dadosLogin);

    if (resultado.situacao === 'TERMO_DE_USO_PENDENTE') {
      window.location.href = resultado.urlParaAceitacaoDoTermoDeUso;
      return;
    }

    const inscricao = resultado.inscricao;

    dispatch(efetuarLoginSucesso({
      ...dadosLogin,
      cpf
    }));

    dispatch(carregarInscricao(inscricao));

    window.cpf = dadosLogin.cpf;
    if (inscricao) {
      dispatch(push('/menu-inscricao'));
      window.nome = inscricao.titular?.nome;
      window.email = inscricao.titular?.contato?.email;
    }
  };

export const efetuarLoginPorCpf = dadosLogin =>
  async dispatch => {
    const { data: inscricao } = await apiDaInscricao().get(`/inscricao/${dadosLogin.cpf}`);

    if (!inscricao)
      dispatch(obteveInformacoesDoTitular({nome: dadosLogin.nome}));

    dispatch(carregarInscricao(inscricao));
    dispatch(efetuarLoginSucesso(dadosLogin));

    if (inscricao)
      dispatch(push('/menu-inscricao'));
  };

export const efetuarLogOut = () => {
  if (ACESSO_ADMINISTRATIVO == localStorage.getItem('tipo_acesso')){
    logoff();
    
    return dispatch => {
      dispatch(logOut());
      dispatch(push('/locais-de-atendimento/logoff-externo'));
    };
  }else
    return dispatch => {
      logoff();
      dispatch(logOut());
      dispatch(cargaInicial());
      dispatch(push('/'));
    };
};